// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2hLWw","list":"styles_list__2LM58"};